import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { RootState } from "../../../store/store";
import { canViewOrganizations } from "../../../constants/organizations";

// /user-list-dashboard/:orgId used to be the org-scoped user list. That list now
// lives in the hierarchy (/organizations/:orgId/users, ADM-5), so old links land
// there. Roles without access to the hierarchy pages (Org Admin) go to the
// global list instead, which the server already scopes to their organizations.
const LegacyUserListRedirect = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const userAccount = useSelector((state: RootState) => state.OrganizationListStore?.userAccount);

  // userAccount is fetched in AppLayout; wait for it to pick the destination.
  if (!userAccount) return null;

  const target =
    orgId && canViewOrganizations(userAccount.user_role)
      ? `/organizations/${orgId}/users`
      : "/user-list-dashboard";
  return <Navigate to={target} replace />;
};

export default LegacyUserListRedirect;
